var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-folder",style:({'opacity': _vm.opacity}),on:{"click":_vm.createFolder}},[_c('img',{attrs:{"src":require("../../../../assets/folder.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }